export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/cartoons_comics.ada2040.svg";